import React, { Component } from 'react'

// lib
import classnames from 'classnames'

// ui
import Button from '../../components/uielements/button'
import { Input } from 'antd'

// icon
import { FaPlusCircle } from 'react-icons/fa'

// redux
import { connect } from 'react-redux'
import objectActions from '../../redux/component_select_object/actions'

const { Search } = Input

class HeadBar extends Component {

    _handleAddClick = () => {
        this.props.setDefaultCurrentObject()
        this.props.showModalCurrentObjectInfo()
    }

    render() {
        return (
            <div className={classnames('row', 'HeaderBar')}>
                <div>
                    <Button
                        type="primary"
                        onClick={() => this._handleAddClick()}
                    >
                        <FaPlusCircle className="iconButton" />
                        Thêm đối tượng
                    </Button>
                </div>
                <div>
                    <Search
                        className="SearchBox"
                        placeholder="Nhập để tìm kiếm"
                        onSearch={value => this.props.searchObject()}
                        onChange={e => this.props.updateTextSearch(e.target.value)}
                        value={this.props.textSearch}
                    />
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        textSearch: state.component_select_object.textSearch
    }
}

const mapDispatchToProps = dispatch => {
    return {
        showModalCurrentObjectInfo: () => {
            dispatch(objectActions.action.showModalCurrentObjectInfo())
        },
        setDefaultCurrentObject: () => {
            dispatch(objectActions.action.setDefaultCurrentObject())
        },
        updateTextSearch: textSearch => {
            dispatch(objectActions.action.updateTextSearch(textSearch))
        },
        searchObject: () => {
            dispatch(objectActions.action.searchObject())
        }
    }
}
 
export default connect(mapStateToProps, mapDispatchToProps)(HeadBar)
